window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};

Sq.Shop.Fetch = {
  get(url, opts = {}) {
    return this._fetch(url, 'GET', null, opts);
  },

  put(url, request, opts = {}) {
    return this._fetch(url, 'PUT', request, opts);
  },

  post(url, request, opts = {}) {
    return this._fetch(url, 'POST', request, opts);
  },

  delete(url, opts = {}) {
    return this._fetch(url, 'DELETE', null, opts);
  },

  _fetch(url, method, data, overrides) {
    const opts = {
      method,
      credentials: 'include',
      headers: {
        'Content-Type': overrides['contentType']
          ? overrides['contentType']
          : 'application/json',
        'X-CSRF-Token': this._getCsrfToken(),
      },
    };

    if (overrides['signal']) {
      opts.signal = overrides['signal'];
    }

    if (data) {
      opts.body = overrides['contentType'] ? data : JSON.stringify(data);
    }

    return fetch(url, opts);
  },

  _getCsrfToken() {
    const csrfTokenMeta = document.querySelector('meta[name=csrf-token]');
    return csrfTokenMeta && csrfTokenMeta.getAttribute('content');
  },
};

export default Sq.Shop.Fetch;
